import * as types from "./comment.actionTypes";
import { AnyAction } from "redux";
import { initialState } from "./comment.initialState";
import { Comment, Reply } from "types/comment.type";
import { compact } from "lodash";

export const commentReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case types.GET_AUDIO_COMMENTS_SUCCESS: {
      const {
        sort,
        episodeId,
        meta: { total, currentPage, lastPage, allComment },
      } = action.payload;

      return {
        ...state,
        comments: {
          ...state.comments,
          [episodeId]: [
            ...(state.sort === sort ? state.comments[episodeId] || [] : []),
            ...action.payload.data.map(
              (cmt) => new Comment({ ...cmt, episodeId })
            ),
          ],
        },
        pagination: {
          ...state.pagination,
          [episodeId]: {
            totalPage: total,
            page: currentPage,
            totalComment: allComment,
          },
        },
        sort,
      };
    }

    case types.ADD_COMMENT_SUCCESS: {
      const { episodeId, comment } = action.payload;
      return {
        ...state,
        comments: {
          ...state.comments,
          [episodeId]: [
            new Comment({ ...comment, episodeId }),
            ...state.comments[episodeId],
          ],
        },
      };
    }

    case types.RESET_COMMENT:
      return { ...state, comments: {} };

    case types.LIKE_COMMENT_SUCCESS:
    case types.UNLIKE_COMMENT_SUCCESS: {
      const { episodeId, commentId, parentId } = action.payload;
      const foundParentComment = state.comments[episodeId].find(
        (cmt) => cmt.id === parentId
      );
      if (foundParentComment) {
        return {
          ...state,
          replies: {
            ...state.replies,
            [foundParentComment.id]: state.replies[foundParentComment.id].map(
              (cmt) => {
                if (cmt.id === commentId) cmt.setIsLike = !cmt.isLiked;
                return cmt;
              }
            ),
          },
        };
      }
      return {
        ...state,
        comments: {
          ...state.comments,
          [episodeId]: state.comments[episodeId].map((cmt) => {
            if (cmt.id === commentId) cmt.setIsLike = !cmt.isLiked;
            return cmt;
          }),
        },
      };
    }

    case types.FETCH_COMMENT_REPLIES_REQUEST: {
      const { commentId } = action.payload;
      return {
        ...state,
        replyLoading: {
          ...state.replyLoading,
          [commentId]: true,
        },
      };
    }

    case types.FETCH_COMMENT_REPLIES_SUCCESS: {
      const { episodeId, commentId } = action.payload;
      return {
        ...state,
        replies: {
          ...state.replies,
          [commentId]: [
            ...(state.replies[commentId] || []),
            ...action.payload.data.map(
              (reply) => new Reply({ ...reply, episodeId })
            ),
          ],
        },
        replyLoading: {
          ...state.replyLoading,
          [commentId]: false,
        },
        replyPagination: {
          ...state.replyPagination,
          [commentId]: {
            totalPage: action.payload.meta.total,
            page: action.payload.meta.currentPage,
            totalComment: action.payload.meta.allComment,
          },
        },
      };
    }

    case types.FETCH_COMMENT_REPLIES_FAILURE: {
      const { commentId } = action.payload;
      return {
        ...state,
        replyLoading: {
          ...state.replyLoading,
          [commentId]: false,
        },
      };
    }

    case types.ADD_COMMENT_REPLY_SUCCESS: {
      const { commentId, episodeId } = action.payload;
      return {
        ...state,
        comments: {
          ...state.comments,
          [episodeId]: state.comments[episodeId].map((cmt) => {
            if (cmt.id === commentId)
              return cmt.reload({ totalReply: cmt.totalReply + 1 });
            return cmt;
          }),
        },
        replies: {
          ...state.replies,
          [commentId]: compact([
            ...(state.replies[commentId] || []),
            new Reply({ ...action.payload.reply, episodeId }),
          ]),
        },
      };
    }

    default:
      return state;
  }
};
